<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-md-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-md-0 me-auto">Profil Kehamilan</h5>
              <router-link
                :to="`/message?userId=${userId}`"
                class="btn btn btn-outline-success mb-1 mb-sm-0"
              >Pesan</router-link>
              <router-link
                :to="`/user-schedules?userId=${userId}`"
                class="btn btn btn-outline-success mb-1 mb-sm-0"
              >Penjadwalan</router-link>
              <router-link
                :to="`/psychology?userId=${userId}`"
                class="btn btn btn-outline-success mb-1 mb-sm-0"
              >Kondisi Kejiwaan</router-link>
              <div class="dropdown d-inline-block">
                <a
                  class="btn btn-primary dropdown-toggle mb-1 mb-sm-0"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >Kelola</a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`user-examination?userId=${userId}`"
                    >Riwayat Pemeriksaan</router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`user-pregnancies?userId=${userId}`"
                    >Daftar Profil Kehamilan</router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`user-assessment?userId=${userId}`"
                    >Assessment</router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`report?userId=${userId}`"
                    >Laporan</router-link>
                  </li>
                  <li>
                    <hr class="my-2">
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`form-examination?userId=${userId}`"
                    >Tambah Pemeriksaan</router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="`form-maternity?userId=${userId}`"
                    >Tambah Profil Kehamilan</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <form @submit.prevent="onSubmit3">
              <div class="row g-4">
                <div class="col-sm-7 col-lg-8 order-2 order-sm-1">
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Nama Responden</label>
                    </div>
                    <div class="col-lg-8">
                      <span
                        class="fw-bold fs-5"
                      > {{ safeGet(dataUser, 'user_profile.fullname')}}</span>
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Nama Kehamilan *</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form3.profile"
                        class="form-control"
                        placeholder="Nama Kehamilan..."
                        autocomplete="off"
                        required
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Deskripsi</label>
                    </div>
                    <div class="col-lg-8">
                      <textarea
                        v-model="form3.description"
                        class="form-control"
                        placeholder="Deskripsi..."
                        rows="3"
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">HPHT *</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="date"
                        v-model="form3.hpht"
                        class="form-control"
                        placeholder="HPHT..."
                        autocomplete="off"
                        required
                      >
                    </div>
                  </div>


                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">HPL</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        v-model="hpl"
                        type="date"
                        class="form-control"
                        placeholder="HPL..."
                        autocomplete="off"
                        disabled
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Usia Kehamilan</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="usiaKehamilan"
                        class="form-control"
                        placeholder="Usia Kehamilan..."
                        autocomplete="off"
                        disabled
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">BB Sebelum Kehamilan *</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form3.pre_pregnancy_weight"
                        class="form-control"
                        placeholder="BB Sebelum Kehamilan..."
                        autocomplete="off"
                        required
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Tahun Kelahiran Sebelumnya</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        v-model="form3.obstetric_history"
                        class="form-control"
                        placeholder="Tahun Kelahiran Sebelumnya..."
                        min="1000"
                        max="3000"
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Jumlah Pernah Cesarean</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        v-model="form3.cesarean_count"
                        class="form-control"
                        placeholder="Jumlah Pernah Cesarean..."
                        min="0"
                        max="100"
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Riwayat Kesehatan</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form3.medical_history"
                        class="form-control"
                        placeholder="Riwayat Kesehatan..."
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <hr>

                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Status Kehamilan</label>
                    </div>
                    <div class="col-lg-8">
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form3.statusId"
                          value="11"
                          class="form-check-input"
                          type="radio"
                          name="status_id"
                          id="inlineRadio11"
                          autocomplete="off"
                        >
                        <label class="form-check-label" for="inlineRadio11">Intrapartum</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form3.statusId"
                          value="12"
                          class="form-check-input"
                          type="radio"
                          name="status_id"
                          id="inlineRadio22"
                          autocomplete="off"
                        >
                        <label class="form-check-label" for="inlineRadio22">Postpartum</label>
                      </div>
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Status Rujukan</label>
                    </div>
                    <div class="col-lg-8">
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form3.referral_status"
                          value="Ya"
                          class="form-check-input"
                          type="radio"
                          name="referral_status"
                          id="inlineRadio1"
                          autocomplete="off"
                        >
                        <label class="form-check-label" for="inlineRadio1">Ya</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          v-model="form3.referral_status"
                          value="Tidak"
                          class="form-check-input"
                          type="radio"
                          name="referral_status"
                          id="inlineRadio2"
                          autocomplete="off"
                          checked
                        >
                        <label class="form-check-label" for="inlineRadio2">Tidak</label>
                      </div>
                    </div>
                  </div>

                  <!-- <div v-if="form3.statusId==12" class="p-4 rounded bg-light">

                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Tanggal Kelahiran *</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="date"
                          v-model="form3.delivery_date"
                          class="form-control bg-white"
                          autocomplete="off"
                          required
                        >
                      </div>
                    </div>
                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Jenis Persalinan *</label>
                      </div>
                      <div class="col-lg-8">
                        <div class="form-check form-check-inline">
                          <input
                            v-model="form3.delivery_type"
                            value="Normal"
                            class="form-check-input"
                            type="radio"
                            name="delivery_type"
                            id="inlineRadio111"
                            autocomplete="off"
                            required
                          >
                          <label class="form-check-label" for="inlineRadio111">Normal</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            v-model="form3.delivery_type"
                            value="Cesarean"
                            class="form-check-input"
                            type="radio"
                            name="delivery_type"
                            id="inlineRadio222"
                            autocomplete="off"
                          >
                          <label class="form-check-label" for="inlineRadio222">Cesarean</label>
                        </div>
                      </div>
                    </div>
                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Kondisi Ibu *</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          v-model="form3.maternal_condition"
                          type="text"
                          class="form-control bg-white"
                          placeholder="Kondisi Ibu..."
                          autocomplete="off"
                          required
                        >
                      </div>
                    </div>
                    <div class="row g-0 g-lg-3 align-items-center">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Kondisi Bayi *</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          v-model="form3.fetal_condition"
                          type="text"
                          class="form-control bg-white"
                          placeholder="Kondisi Bayi..."
                          autocomplete="off"
                          required
                        >
                      </div>
                    </div>
                  </div> -->
                </div>

                <div class="col-sm-5 col-lg-3 order-1 order-sm-2">
                  <div class="bg-success-subtle rounded-4 p-2 shadow-sm">
                    <img
                      v-if="preview != ''"
                      :src="preview"
                      alt="preview"
                      class="img-fluid rounded-3"
                    >
                    <img
                      v-else-if="preview == ''"
                      src="../assets/images/profile/user-7.jpg"
                      class="img-fluid rounded-3"
                      alt="no-img"
                    >
                    <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                  </div>
                </div>
              </div>

              <button type="submit" class="btn btn-primary mt-4">{{id ? 'Update' : 'Simpan'}}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import config from "../config";
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			userID: this.$route.query.userId,
			name: '',
			token: localStorage.getItem('token'),
			name: '',
			attachment: '',
			form3: {
				profile: '',
				description: '',
				hpht: '',
				pre_pregnancy_weight: '',
				obstetric_history: '',
				cesarean_count: '',
				medical_history: '',
				statusId: '', //11 atau 12
				delivery_date: '',
				delivery_type: '', //Normal
				maternal_condition: '',
				fetal_condition: '',
				referral_status: '' //Tidak
			},
			file: null,
			// preview: '',
			title: 'Tambah',
			button: 'Simpan'
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.form3 = {
			profile: '',
			description: '',
			hpht: '',
			pre_pregnancy_weight: '',
			obstetric_history: '',
			cesarean_count: '',
			medical_history: '',
			statusId: '', //11 atau 12
			delivery_date: '',
			delivery_type: '',
			maternal_condition: '',
			fetal_condition: '',
			referral_status: ''
		}

		this.title = 'Tambah'
		this.button = 'Simpan'

		next()
	},

	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		// get detail user
		//jika edit, get detail kehamilan
		if (this.id) {
			this.$store
				.dispatch('location/getDataPayload2', {
					url: `user_pregnancies/${this.id}`
				})
				.then((res) => {
					let data = res.payload
					this.form3 = {
						profile: data.profile,
						description: data.description,
						hpht: data.hpht,
						pre_pregnancy_weight: data.pre_pregnancy_weight,
						obstetric_history: data.obstetric_history,
						cesarean_count: data.cesarean_count,
						medical_history: data.medical_history,
						statusId: data.statusId, //11 atau 12
						delivery_date: data.delivery_date,
						delivery_type: data.delivery_type,
						maternal_condition: data.maternal_condition,
						fetal_condition: data.fetal_condition,
						referral_status: data.referral_status
					}
					console.log(res.payload.userId)
					this.userId = res.payload.userId
					this.$store
						.dispatch('location/getDataPayload', {
							url: `users/${res.payload.userId}`
						})
						.then((res) => {
							this.name = res.payload.user_profile.fullname
						})
				})
		} else {
			if (this.userId) {
				this.$store
					.dispatch('location/getDataPayload', {
						url: `users/${this.userId}`
					})
					.then((res) => {})
			}
		}
	},
	computed: {
		...mapGetters({
			dataUser: 'location/getDataPayloadObject'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataUser && this.dataUser.user_profile) {
					if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					} else {
						url = config("api.baseUrl") + 'storage/uploads/' + this.dataUser.user_profile.attachment
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataUser.user_profile.attachment = value
			}
		},
		usia: {
			// getter
			get() {
				return this.hitungUsia(this.form.birth_date)
			}
		},
		hpl: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).hpl
			}
		},
		usiaKehamilan: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).usiaMinggu
			}
		},
		userId: {
			// getter
			get() {
				return this.userID || ''
			},
			set(value) {
				this.userID = value
			}
		},
		id: {
			// getter
			get() {
				return this.$route.query.id || ''
			}
		},
		type: {
			// getter
			get() {
				return this.$route.query.type || 'admin'
			}
		}
	},
	methods: {
		onSubmit3() {
			let endpoint = 'user_pregnancies/' + this.userId
			this.method = 'POST'
			// jika edit
			if (this.id != '') {
				endpoint = 'user_pregnancies/update/' + this.id
				this.method = 'PUT'
			}

			this.form3.hpl = this.hpl
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form3,
					url: endpoint,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.$router.push(`/user-pregnancies?userId=${this.userId}`)
					} else {
					}
				})
		},
		hitungUsia(tanggalLahir) {
			const today = new Date()
			const birthDate = new Date(tanggalLahir)
			let age = today.getFullYear() - birthDate.getFullYear()
			const m = today.getMonth() - birthDate.getMonth()

			// kalau bulan belum lewat, atau bulan sama tapi hari belum lewat → usia dikurangi 1
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--
			}

			return age
		},
		hitungHplDanUsia(hpht) {
			const hphtDate = new Date(hpht)
			if (isNaN(hphtDate)) {
				return { error: 'Format tanggal salah (gunakan YYYY-MM-DD)' }
			}

			// --- HPL (HPHT + 280 hari) ---
			const hplDate = new Date(hphtDate)
			hplDate.setDate(hplDate.getDate() + 280)

			// --- Usia Kehamilan ---
			const today = new Date()
			let diffMs = today - hphtDate // selisih dalam ms
			if (diffMs < 0) {
				return { error: 'HPHT tidak boleh setelah hari ini' }
			}

			let usiaHari = Math.floor(diffMs / (1000 * 60 * 60 * 24))
			let usiaMinggu = Math.floor(usiaHari / 7)
			let sisaHari = usiaHari % 7

			return {
				hpl: hplDate.toISOString().split('T')[0], // format YYYY-MM-DD
				usiaHari,
				usiaMinggu,
				keterangan: `${usiaMinggu} minggu ${sisaHari} hari`
			}
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
